import { FC, useEffect, useState, useCallback } from "react"
import { useParams } from "react-router-dom"
import { observer } from "mobx-react"
import { Table, Button } from "antd"
import { ReloadOutlined } from "@ant-design/icons"
import { battlePassColumns } from "./columns"
import { GrantBattlePass } from "./grant-battle-pass"
import { RevokeBattlePass } from "./revoke-battle-pass"
import { BattlePass } from "../store/types"
import { getBattlePassHistory } from "../api/accounts.call"

export const AccountBattlePass: FC = observer<FC>(() => {
  const { id } = useParams<{ id: string }>()
  const [visibleGrantBattlePassModal, setGrantBattlePassModalVisibility] = useState<boolean>(false)
  const [visibleRevokeBattlePassModal, setRevokeBattlePassModalVisibility] = useState<boolean>(false)
  const [battlePasses, setBattlePasses] = useState<BattlePass[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const loadBattlePasses = useCallback(async() => {
    if (!id) {
      return
    }
    setIsLoading(true)
    const result = await getBattlePassHistory(id)
    setBattlePasses(result?.data || [])
    setIsLoading(false)
  }, [id])

  useEffect(() => {
    loadBattlePasses()
  }, [loadBattlePasses])

  return (
    <>
      <div style={{ marginBottom: "16px" }}>
        <Button
          type="primary"
          onClick={() => setGrantBattlePassModalVisibility(true)}
          style={{ marginRight: "8px" }}
        >
          Grant Buff Pass
        </Button>
        <Button
          danger
          onClick={() => setRevokeBattlePassModalVisibility(true)}
          style={{ marginRight: "8px" }}
        >
          Revoke Buff Pass
        </Button>
        <Button
          icon={<ReloadOutlined />}
          onClick={loadBattlePasses}
          loading={isLoading}
        >
          Reload
        </Button>
      </div>
      <Table
        dataSource={battlePasses}
        columns={battlePassColumns as any}
        rowKey="season"
        loading={isLoading}
      />
      <GrantBattlePass
        visible={visibleGrantBattlePassModal}
        onClose={() => setGrantBattlePassModalVisibility(false)}
        onSuccess={loadBattlePasses}
      />
      <RevokeBattlePass
        visible={visibleRevokeBattlePassModal}
        onClose={() => setRevokeBattlePassModalVisibility(false)}
        onSuccess={loadBattlePasses}
      />
    </>
  )
})

